module.exports = __webpack_public_path__ + "static/media/ai_agent_topimage.001.490bc9eb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ai_agent_topimage.001.jpeg
// module id = 316
// module chunks = 0